import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(!!api.getToken());

  useEffect(() => {
    const token = api.getToken();
    if (token) {
      api.getMe().then(u => { setUser(u); setLoading(false); }).catch(() => { api.clearToken(); setLoading(false); });
    } 
  }, []);

  const login = useCallback(async (id, password) => {
    const res = await api.login(id, password);
    api.setToken(res.token, res.user?.role);
    setUser(res.user);
    return res.user;
  }, []);

  const logout = useCallback(() => {
    api.clearToken();
    setUser(null);
  }, []);

  const refreshUser = useCallback(async () => {
    const u = await api.getMe();
    setUser(u);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loading, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
